import { render, staticRenderFns } from "./ProLabel.vue?vue&type=template&id=1472c9fc&scoped=true"
import script from "./ProLabel.vue?vue&type=script&lang=js"
export * from "./ProLabel.vue?vue&type=script&lang=js"
import style0 from "./ProLabel.vue?vue&type=style&index=0&id=1472c9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472c9fc",
  null
  
)

export default component.exports